// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import {
//   Phone,
//   MessageCircle,
//   MapPin,
//   Circle,
//   Star,
//   ArrowLeft,
//   ShieldCheck,
//   X,
// } from "lucide-react";


// import mehak from "../../../../assets/Mehak.png";
// import delhi from "../../../../assets/indiagate.webp";
// import gaziabad from "../../../../assets/ghaziabad.webp";
// import gurugram from "../../../../assets/gurugram.webp";
// import noida from "../../../../assets/noida.webp";

// import { VEHICLE_IMAGES } from "../../../../Utils/Vehicleimg";

// const TrackingOrderCard = ({
//   onNext,
//   onBack,
//   onCancel,
//   formData,
//   selectedVehicle = "Two Wheeler",
//   acceptedRide,
// }) => {
//   const location = useLocation();
//   const navigate = useNavigate();

//   const mapRef = useRef(null);
//   const googleMapRef = useRef(null);
//   const pickupMarkerRef = useRef(null);
//   const dropMarkerRef = useRef(null);
//   const driverMarkerRef = useRef(null);
//   const routeLineRef = useRef(null);
//   const driverLineRef = useRef(null);

//   const [showCancelModal, setShowCancelModal] = useState(false);
//   const [cancelReason, setCancelReason] = useState("");

//   const selectedCity = location.state?.city || "Delhi";
// const { car, truck, auto, bike } = VEHICLE_IMAGES;

//   const cityBanners = {
//     Delhi: delhi,
//     Gaziabad: gaziabad,
//     Gurugram: gurugram,
//     Noida: noida,
//   };

//   const banner = cityBanners[selectedCity] || delhi;

//   const acceptedDriver = acceptedRide?.acceptedDriver || {
//     id: 1,
//     name: "Mehak Aggarwal",
//     rating: "4.8",
//     distance: "1.5 km",
//     eta: "5 mins",
//     image: mehak,
//   };

//   const cancellationReasons = [
//     "Changed my mind",
//     "Pickup address is wrong",
//     "Drop address is wrong",
//     "Driver is taking too long",
//     "Booked by mistake",
//     "Need to change vehicle",
//     "Fare is too high",
//     "Other reason",
//   ];

//   const totalPrice = acceptedRide?.totalPrice || 80;
//   const selectedExtra = acceptedRide?.selectedExtra || 0;

//   const getVehicleIcon = () => {
//     const name = String(selectedVehicle || "").toLowerCase();

//     if (name.includes("three") || name.includes("auto")) return auto;

//     if (
//       name.includes("four") ||
//       name.includes("eeco") ||
//       name.includes("car")
//     ) {
//       return car;
//     }

//     if (name.includes("truck") || name.includes("mini")) return truck;

//     return bike;
//   };

//   const vehicleIcon = getVehicleIcon();

//   const cleanNumber = (value, fallback) => {
//     const number = Number(value);
//     return Number.isFinite(number) ? number : fallback;
//   };

//   const pickupLocation = useMemo(() => {
//     return {
//       lat: cleanNumber(
//         formData?.pickupLatitude ||
//           formData?.pickupLat ||
//           formData?.pickup_latitude,
//         28.6139,
//       ),
//       lng: cleanNumber(
//         formData?.pickupLongitude ||
//           formData?.pickupLng ||
//           formData?.pickup_longitude,
//         77.209,
//       ),
//     };
//   }, [formData]);

//   const dropLocation = useMemo(() => {
//     return {
//       lat: cleanNumber(
//         formData?.dropLatitude || formData?.dropLat || formData?.drop_latitude,
//         pickupLocation.lat + 0.018,
//       ),
//       lng: cleanNumber(
//         formData?.dropLongitude ||
//           formData?.dropLng ||
//           formData?.drop_longitude,
//         pickupLocation.lng + 0.018,
//       ),
//     };
//   }, [formData, pickupLocation]);

//   const driverLocation = useMemo(() => {
//     return {
//       lat: pickupLocation.lat + 0.006,
//       lng: pickupLocation.lng - 0.007,
//     };
//   }, [pickupLocation]);

//   const randomOtp = useMemo(() => {
//     return String(Math.floor(1000 + Math.random() * 9000)).split("");
//   }, [acceptedDriver?.id]);

//   const registrationNumber = useMemo(() => {
//     const registrations = [
//       "DL 3C AG 4521",
//       "DL 8S BX 9134",
//       "HR 26 DK 7845",
//       "UP 16 CT 2291",
//       "DL 5S AB 6702",
//       "HR 55 AQ 3428",
//       "UP 14 EQ 9187",
//       "DL 1R CN 5046",
//     ];

//     const driverId = Number(acceptedDriver?.id || 1);
//     const index = driverId % registrations.length;

//     return registrations[index];
//   }, [acceptedDriver?.id]);

//   const orderId = useMemo(() => {
//     return "PKY" + Date.now().toString().slice(-10);
//   }, []);

//   const loadGoogleMap = () => {
//     const googleKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

//     if (!googleKey) {
//       console.error("Google Maps API key missing in .env");
//       return;
//     }

//     if (window.google?.maps) {
//       initMap();
//       return;
//     }

//     const existingScript = document.getElementById("google-maps-script");

//     if (existingScript) {
//       existingScript.addEventListener("load", initMap);
//       return;
//     }

//     const script = document.createElement("script");
//     script.id = "google-maps-script";
//     script.src = `https://maps.googleapis.com/maps/api/js?key=${googleKey}`;
//     script.async = true;
//     script.defer = true;
//     script.onload = initMap;

//     document.body.appendChild(script);
//   };

//   const initMap = () => {
//     if (!mapRef.current || !window.google?.maps) return;

//     if (!googleMapRef.current) {
//       googleMapRef.current = new window.google.maps.Map(mapRef.current, {
//         center: pickupLocation,
//         zoom: 14,
//         disableDefaultUI: true,
//         zoomControl: true,
//         fullscreenControl: true,
//         streetViewControl: false,
//         mapTypeControl: false,
//       });
//     }

//     renderMap();
//   };

//   const clearMapItems = () => {
//     if (pickupMarkerRef.current) pickupMarkerRef.current.setMap(null);
//     if (dropMarkerRef.current) dropMarkerRef.current.setMap(null);
//     if (driverMarkerRef.current) driverMarkerRef.current.setMap(null);
//     if (routeLineRef.current) routeLineRef.current.setMap(null);
//     if (driverLineRef.current) driverLineRef.current.setMap(null);
//   };

//   const renderMap = () => {
//     if (!window.google?.maps || !googleMapRef.current) return;

//     const map = googleMapRef.current;

//     clearMapItems();

//     pickupMarkerRef.current = new window.google.maps.Marker({
//       map,
//       position: pickupLocation,
//       title: "Pickup Location",
//       label: {
//         text: "P",
//         color: "#ffffff",
//         fontWeight: "700",
//       },
//       icon: {
//         path: window.google.maps.SymbolPath.CIRCLE,
//         scale: 13,
//         fillColor: "#2563eb",
//         fillOpacity: 1,
//         strokeColor: "#ffffff",
//         strokeWeight: 4,
//       },
//     });

//     dropMarkerRef.current = new window.google.maps.Marker({
//       map,
//       position: dropLocation,
//       title: "Drop Location",
//       label: {
//         text: "D",
//         color: "#ffffff",
//         fontWeight: "700",
//       },
//       icon: {
//         path: window.google.maps.SymbolPath.CIRCLE,
//         scale: 13,
//         fillColor: "#16a34a",
//         fillOpacity: 1,
//         strokeColor: "#ffffff",
//         strokeWeight: 4,
//       },
//     });

//     driverMarkerRef.current = new window.google.maps.Marker({
//       map,
//       position: driverLocation,
//       title: acceptedDriver?.name || "Driver",
//       icon: {
//         url: vehicleIcon,
//         scaledSize: new window.google.maps.Size(42, 42),
//         anchor: new window.google.maps.Point(21, 21),
//       },
//     });

//     routeLineRef.current = new window.google.maps.Polyline({
//       map,
//       path: [pickupLocation, dropLocation],
//       geodesic: true,
//       strokeColor: "#2563eb",
//       strokeOpacity: 0.95,
//       strokeWeight: 5,
//     });

//     driverLineRef.current = new window.google.maps.Polyline({
//       map,
//       path: [driverLocation, pickupLocation],
//       geodesic: true,
//       strokeColor: "#f97316",
//       strokeOpacity: 0.95,
//       strokeWeight: 4,
//       icons: [
//         {
//           icon: {
//             path: "M 0,-1 0,1",
//             strokeOpacity: 1,
//             scale: 4,
//           },
//           offset: "0",
//           repeat: "18px",
//         },
//       ],
//     });

//     const driverInfoWindow = new window.google.maps.InfoWindow({
//       content: `
//         <div style="font-family:Arial; min-width:170px;">
//           <b>${acceptedDriver?.name || "Driver"}</b>
//           <div style="font-size:12px; margin-top:4px;">
//             Rating: ${acceptedDriver?.rating || "-"} ⭐<br/>
//             ETA: ${acceptedDriver?.eta || "-"}<br/>
//             Vehicle: ${selectedVehicle}
//           </div>
//         </div>
//       `,
//     });

//     driverMarkerRef.current.addListener("click", () => {
//       driverInfoWindow.open(map, driverMarkerRef.current);
//     });

//     const bounds = new window.google.maps.LatLngBounds();

//     bounds.extend(pickupLocation);
//     bounds.extend(dropLocation);
//     bounds.extend(driverLocation);

//     map.fitBounds(bounds);

//     setTimeout(() => {
//       if (map.getZoom() > 15) {
//         map.setZoom(15);
//       }
//     }, 300);
//   };

//   useEffect(() => {
//     loadGoogleMap();
//   }, []);

//   useEffect(() => {
//     if (window.google?.maps && googleMapRef.current) {
//       renderMap();
//     }
//   }, [
//     pickupLocation,
//     dropLocation,
//     driverLocation,
//     acceptedDriver,
//     vehicleIcon,
//   ]);

//   const handleCancelConfirm = () => {
//     if (!cancelReason) return;

//     setShowCancelModal(false);
//     setCancelReason("");

//     if (onCancel) {
//       onCancel({
//         reason: cancelReason,
//         orderId,
//         acceptedDriver,
//         totalPrice,
//       });
//       return;
//     }

//     navigate("/two-wheeler");
//   };

//   return (
//     <>
//       <section className="w-full px-3 pb-6 pt-8 sm:px-4 md:px-6 md:pt-12 lg:px-0 lg:pt-0">
//         {/* BACKGROUND */}
//         <div className="image-section absolute left-0 top-0 -z-10 !h-[70%] w-full">
//           <img
//             src={banner}
//             alt="bg"
//             className="h-full w-full object-cover object-top"
//           />
//           <div className="image-overlay absolute inset-0 bg-black/30"></div>
//         </div>

//    <div className="mx-auto mt-8 grid w-full max-w-[1020px] grid-cols-1 overflow-hidden rounded-[26px] border border-white/80 bg-white shadow-[0_22px_70px_rgba(15,23,42,0.16)] sm:mt-4 md:mt-8 lg:mt-[80px] lg:h-[850px] lg:grid-cols-[57%_43%]">
//           {/* LEFT SECTION */}
//       <div className="order-2 flex h-full min-h-0 flex-col overflow-y-auto bg-white px-5 py-5 sm:px-7 md:px-6 lg:order-1 lg:px-6 lg:py-5 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
//             <div className="w-full">
//               {/* BACK */}
//               <button
//                 type="button"
//                 onClick={onBack}
//                 className="mb-3 inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
//               >
//                 <ArrowLeft size={17} />
//                 Back
//               </button>

//               {/* STATUS */}
//               <div className="mb-3 flex flex-col gap-3 rounded-2xl border border-green-100 bg-green-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-5">
//                 <div className="min-w-0 flex-1">
//                   <h3 className="text-[17px] font-bold text-green-700 sm:text-[18px]">
//                     Driver is on the Way
//                   </h3>

//                   <p className="mt-1 text-sm leading-5 text-slate-600">
//                     {acceptedDriver.name} is heading to pickup location{" "}
//                     {acceptedDriver.distance} away
//                   </p>
//                 </div>

//                 <button
//                   type="button"
//                   className="w-fit shrink-0 rounded-xl bg-[#f97316] px-4 py-2 text-center text-sm font-bold text-white transition hover:bg-[#ea580c] sm:min-w-[72px]"
//                 >
//                   {acceptedDriver.eta}
//                 </button>
//               </div>

//               {/* DRIVER */}
//               <div className="mb-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
//                 <div className="flex flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
//                   <div className="flex min-w-0 items-start gap-3">
//                     <div className="relative shrink-0">
//                       <img
//                         src={acceptedDriver.image}
//                         alt="driver"
//                         className="h-14 w-14 rounded-full object-cover"
//                       />

//                       <span className="absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-green-500 ring-2 ring-white">
//                         <ShieldCheck size={14} className="text-white" />
//                       </span>
//                     </div>

//                     <div className="min-w-0 flex-1">
//                       <h4 className="inline-block max-w-full truncate rounded-full bg-orange-100 px-3 py-1 text-[14px] font-bold text-slate-800 sm:text-[15px]">
//                         {acceptedDriver.name}
//                       </h4>

//                       <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-slate-500 sm:text-sm">
//                         <span>{selectedVehicle}</span>
//                         <span>|</span>
//                         <span>{registrationNumber}</span>
//                       </div>

//                       <div className="mt-2 flex flex-wrap items-center gap-1 text-xs text-slate-500 sm:text-sm">
//                         <Star
//                           size={14}
//                           className="fill-yellow-400 text-yellow-400"
//                         />
//                         <span>{acceptedDriver.rating}</span>
//                         <span>•</span>
//                         <span>{acceptedDriver.distance}</span>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-2 gap-2 sm:flex sm:shrink-0">
//                     <button
//                       type="button"
//                       className="flex h-10 items-center justify-center gap-2 rounded-xl bg-green-100 px-3 text-sm font-semibold text-green-700 sm:h-9 sm:w-9 sm:px-0"
//                     >
//                       <Phone size={18} />
//                       <span className="sm:hidden">Call</span>
//                     </button>

//                     <button
//                       type="button"
//                       className="flex h-10 items-center justify-center gap-2 rounded-xl bg-blue-100 px-3 text-sm font-semibold text-blue-700 sm:h-9 sm:w-9 sm:px-0"
//                     >
//                       <MessageCircle size={18} />
//                       <span className="sm:hidden">Chat</span>
//                     </button>
//                   </div>
//                 </div>

//                 <div className="flex flex-col gap-3 border-t bg-slate-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-2 sm:py-2">
//                   <p className="text-sm font-medium text-slate-700">
//                     Start your Order with PIN
//                   </p>

//                   <div className="flex gap-2 sm:gap-1">
//                     {randomOtp.map((num, index) => (
//                       <span
//                         key={index}
//                         className="flex h-8 w-8 items-center justify-center rounded-lg border bg-white text-sm font-bold text-slate-700 sm:h-7 sm:w-7"
//                       >
//                         {num}
//                       </span>
//                     ))}
//                   </div>
//                 </div>
//               </div>

//               {/* DELIVERY INFO */}
//               <div className="mb-3 rounded-2xl border border-slate-200 bg-white">
//                 <div className="border-b px-4 py-2">
//                   <h3 className="text-[18px] font-bold text-slate-800">
//                     Delivery Info
//                   </h3>
//                 </div>

//                 <div className="relative min-h-[75px] px-4 py-4 pl-10">
//                   <div className="absolute left-5 top-6 h-[50px] border-l border-dashed border-slate-300"></div>

//                   <Circle
//                     size={11}
//                     className="absolute left-[15px] top-5 text-blue-500"
//                   />

//                   <MapPin
//                     size={14}
//                     className="absolute left-[13px] top-[60px] text-green-600"
//                     fill="currentColor"
//                   />

//                   <div className="space-y-4">
//                     <p className="break-words text-sm leading-6 text-slate-500">
//                       {formData?.pickupAddress || "Pickup address not added"}
//                     </p>

//                     <p className="break-words text-sm leading-6 text-slate-500">
//                       {formData?.dropAddress || "Drop address not added"}
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* ADDITIONAL INFO */}
//               <div className="mb-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
//                 <h3 className="border-b px-4 py-2 text-[18px] font-bold text-slate-800">
//                   Additional Info
//                 </h3>

//                 <div className="space-y-2 px-4 py-3 text-sm">
//                   <div className="flex justify-between gap-4">
//                     <span className="font-semibold text-slate-500">
//                       Order ID
//                     </span>
//                     <span className="text-right text-slate-500">{orderId}</span>
//                   </div>

//                   <div className="flex justify-between gap-4">
//                     <span className="font-semibold text-slate-500">
//                       Receiver Name
//                     </span>
//                     <span className="text-right text-slate-500">
//                       {formData?.receiverName || "-"}
//                     </span>
//                   </div>

//                   <div className="flex justify-between gap-4">
//                     <span className="font-semibold text-slate-500">
//                       Receiver Number
//                     </span>
//                     <span className="text-right text-slate-500">
//                       {formData?.receiverMobile || "-"}
//                     </span>
//                   </div>

//                   {formData?.deliveryType === "schedule" && (
//                     <div className="flex justify-between gap-4">
//                       <span className="font-semibold text-slate-500">
//                         Schedule
//                       </span>
//                       <span className="text-right text-slate-500">
//                         {formData?.scheduleDate || "-"}{" "}
//                         {formData?.scheduleTime || ""}
//                       </span>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* VEHICLE PRICE */}
//               <div className="mb-3 flex items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3">
//                 <div className="flex items-center gap-3">
//                   <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-orange-300 bg-orange-50">
//                     <img
//                       src={vehicleIcon}
//                       alt={selectedVehicle}
//                       className="h-[45px] w-[55px] object-contain"
//                     />
//                   </div>

//                   <div>
//                     <h4 className="font-bold text-slate-800">
//                       {selectedVehicle}
//                     </h4>
//                     <p className="text-sm text-slate-500">Upto 20 kg</p>

//                     {selectedExtra > 0 && (
//                       <p className="text-xs font-semibold text-green-600">
//                         Extra fare added: ₹{selectedExtra}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 <div className="text-right">
//                   <p className="text-sm text-slate-500">Total Price</p>
//                   <h3 className="text-[18px] font-bold text-slate-900">
//                     ₹{totalPrice}
//                   </h3>
//                 </div>
//               </div>
//             </div>

//             {/* BUTTONS */}
//             <div className="mt-auto grid grid-cols-1 gap-3 sm:grid-cols-2">
//               <button
//                 type="button"
//                 onClick={() => setShowCancelModal(true)}
//                 className="rounded-2xl border border-red-100 bg-red-50 py-3 font-bold text-red-600 transition hover:bg-red-100"
//               >
//                 Cancel Order
//               </button>

//               <button
//                 type="button"
//                 onClick={() => {}}
//                 className="w-full rounded-2xl bg-[#1f2d3f] py-3 font-semibold text-white transition hover:opacity-90"
//               >
//                 Contact Support
//               </button>
//             </div>
//           </div>

//           {/* RIGHT REAL MAP */}
//           <div className="order-1 flex h-[420px] bg-slate-100 p-4 sm:h-[460px] md:h-[500px] lg:order-2 lg:h-full lg:p-5">
//             <div className="relative h-full w-full overflow-hidden rounded-3xl border border-white/70 bg-white shadow-inner">
//               <div ref={mapRef} className="h-full w-full" />
//             </div>
//           </div>
//         </div>
//       </section>

//       {showCancelModal && (
//         <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 px-4">
//           <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl">
//             <div className="mb-4 flex items-center justify-between">
//               <div>
//                 <h3 className="text-lg font-bold text-slate-900">
//                   Cancel Order
//                 </h3>
//                 <p className="mt-1 text-sm text-slate-500">
//                   Please select a cancellation reason.
//                 </p>
//               </div>

//               <button
//                 type="button"
//                 onClick={() => {
//                   setShowCancelModal(false);
//                   setCancelReason("");
//                 }}
//                 className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-600 hover:bg-slate-200"
//               >
//                 <X size={18} />
//               </button>
//             </div>

//             <div className="mb-5">
//               <label className="mb-2 block text-sm font-semibold text-slate-700">
//                 Cancellation Reason
//               </label>

//               <select
//                 value={cancelReason}
//                 onChange={(e) => setCancelReason(e.target.value)}
//                 className="w-full rounded-lg border border-slate-300 bg-white px-3 py-3 text-sm text-slate-700 outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100"
//               >
//                 <option value="">Select reason</option>

//                 {cancellationReasons.map((reason) => (
//                   <option key={reason} value={reason}>
//                     {reason}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
//               <button
//                 type="button"
//                 onClick={() => {
//                   setShowCancelModal(false);
//                   setCancelReason("");
//                 }}
//                 className="rounded-lg border border-slate-200 bg-white py-3 font-bold text-slate-700 hover:bg-slate-50"
//               >
//                 Keep Order
//               </button>

//               <button
//                 type="button"
//                 disabled={!cancelReason}
//                 onClick={handleCancelConfirm}
//                 className={`rounded-lg py-3 font-bold text-white transition ${
//                   cancelReason
//                     ? "bg-red-600 hover:bg-red-700"
//                     : "cursor-not-allowed bg-red-300"
//                 }`}
//               >
//                 Confirm Cancel
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default TrackingOrderCard;

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Phone,
  MessageCircle,
  MapPin,
  Circle,
  Star,
  ArrowLeft,
  ShieldCheck,
  X,
} from "lucide-react";


import mehak from "../../../../assets/Mehak.png";
import delhi from "../../../../assets/indiagate.webp";
import gaziabad from "../../../../assets/ghaziabad.webp";
import gurugram from "../../../../assets/gurugram.webp";
import noida from "../../../../assets/noida.webp";
import useCustomerDetails from "../../../Services/Customer/useCustomerDetails";
import { VEHICLE_IMAGES } from "../../../../Utils/Vehicleimg";

const TrackingOrderCard = ({
  onNext,
  onBack,
  onCancel,
  formData,
  selectedVehicle = "Two Wheeler",
  acceptedRide,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { computeDistanceRouteApi, computeDistanceRouteLoading } =
  useCustomerDetails();

  const mapRef = useRef(null);
  const googleMapRef = useRef(null);
  const pickupMarkerRef = useRef(null);
  const dropMarkerRef = useRef(null);
  const driverMarkerRef = useRef(null);
  const routeLineRef = useRef(null);
  const driverLineRef = useRef(null);

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
const [computedRoutePath, setComputedRoutePath] = useState([]);
const [routeDistanceText, setRouteDistanceText] = useState("");
const [routeDurationText, setRouteDurationText] = useState("");

  const selectedCity = location.state?.city || "Delhi";
const customerId =
  formData?.customerId ||
  formData?.userId ||
  formData?.userCode ||
  JSON.parse(sessionStorage.getItem("user") || "{}")?.userCode ||
  JSON.parse(sessionStorage.getItem("user") || "{}")?.userid ||
  "";

 const { car, truck, auto, bike } = VEHICLE_IMAGES;

  const cityBanners = {
    Delhi: delhi,
    Gaziabad: gaziabad,
    Gurugram: gurugram,
    Noida: noida,
  };

  const banner = cityBanners[selectedCity] || delhi;

  const acceptedDriver = acceptedRide?.acceptedDriver || {
    id: 1,
    name: "Mehak Aggarwal",
    rating: "4.8",
    distance: "1.5 km",
    eta: "5 mins",
    image: mehak,
  };

  const cancellationReasons = [
    "Changed my mind",
    "Pickup address is wrong",
    "Drop address is wrong",
    "Driver is taking too long",
    "Booked by mistake",
    "Need to change vehicle",
    "Fare is too high",
    "Other reason",
  ];

  const totalPrice = acceptedRide?.totalPrice || 80;
  const selectedExtra = acceptedRide?.selectedExtra || 0;

  const getVehicleIcon = () => {
    const name = String(selectedVehicle || "").toLowerCase();

    if (name.includes("three") || name.includes("auto")) return auto;

    if (
      name.includes("four") ||
      name.includes("eeco") ||
      name.includes("car")
    ) {
      return car;
    }

    if (name.includes("truck") || name.includes("mini")) return truck;

    return bike;
  };

  const vehicleIcon = getVehicleIcon();

  const cleanNumber = (value, fallback) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  };

  const pickupLocation = useMemo(() => {
    return {
      lat: cleanNumber(
        formData?.pickupLatitude ||
          formData?.pickupLat ||
          formData?.pickup_latitude,
        28.6139,
      ),
      lng: cleanNumber(
        formData?.pickupLongitude ||
          formData?.pickupLng ||
          formData?.pickup_longitude,
        77.209,
      ),
    };
  }, [formData]);

  const dropLocation = useMemo(() => {
    return {
      lat: cleanNumber(
        formData?.dropLatitude || formData?.dropLat || formData?.drop_latitude,
        pickupLocation.lat + 0.018,
      ),
      lng: cleanNumber(
        formData?.dropLongitude ||
          formData?.dropLng ||
          formData?.drop_longitude,
        pickupLocation.lng + 0.018,
      ),
    };
  }, [formData, pickupLocation]);

  const driverLocation = useMemo(() => {
    return {
      lat: pickupLocation.lat + 0.006,
      lng: pickupLocation.lng - 0.007,
    };
  }, [pickupLocation]);

  useEffect(() => {
  const fetchComputedRoute = async () => {
    const hasPickup =
      pickupLocation?.lat &&
      pickupLocation?.lng &&
      Number.isFinite(Number(pickupLocation.lat)) &&
      Number.isFinite(Number(pickupLocation.lng));

    const hasDrop =
      dropLocation?.lat &&
      dropLocation?.lng &&
      Number.isFinite(Number(dropLocation.lat)) &&
      Number.isFinite(Number(dropLocation.lng));

    if (!hasPickup || !hasDrop) return;

    const result = await computeDistanceRouteApi({
      originLatitude: String(pickupLocation.lat),
      originLongitude: String(pickupLocation.lng),
      destinationLatitude: String(dropLocation.lat),
      destinationLongitude: String(dropLocation.lng),
      customerId,
    });

    const normalizedRoute = normalizeComputedRoute(result);

    setRouteDistanceText(normalizedRoute.distanceText || "");
    setRouteDurationText(normalizedRoute.durationText || "");

    if (normalizedRoute.path.length > 1) {
      setComputedRoutePath(normalizedRoute.path);
    } else {
      setComputedRoutePath([pickupLocation, dropLocation]);
    }
  };

  fetchComputedRoute();
}, [
  pickupLocation.lat,
  pickupLocation.lng,
  dropLocation.lat,
  dropLocation.lng,
  customerId,
]);

  const normalizeComputedRoute = (apiResponse) => {
  const data =
    apiResponse?.response ||
    apiResponse?.data ||
    apiResponse?.result ||
    apiResponse ||
    {};

  const routeData = Array.isArray(data) ? data[0] : data;

  const encodedPolyline =
    routeData?.encodedPolyline ||
    routeData?.polyline ||
    routeData?.overview_polyline?.points ||
    routeData?.routes?.[0]?.polyline?.encodedPolyline ||
    routeData?.routes?.[0]?.overview_polyline?.points ||
    routeData?.routes?.[0]?.polyline ||
    "";

  const distanceText =
    routeData?.distanceText ||
    routeData?.distance ||
    routeData?.routes?.[0]?.distanceText ||
    routeData?.routes?.[0]?.legs?.[0]?.distance?.text ||
    "";

  const durationText =
    routeData?.durationText ||
    routeData?.duration ||
    routeData?.routes?.[0]?.durationText ||
    routeData?.routes?.[0]?.legs?.[0]?.duration?.text ||
    "";

  const routePoints =
    routeData?.route ||
    routeData?.path ||
    routeData?.points ||
    routeData?.coordinates ||
    routeData?.routes?.[0]?.path ||
    routeData?.routes?.[0]?.points ||
    [];

  let finalPath = [];

  if (
    encodedPolyline &&
    window.google?.maps?.geometry?.encoding?.decodePath
  ) {
    finalPath = window.google.maps.geometry.encoding
      .decodePath(encodedPolyline)
      .map((point) => ({
        lat: point.lat(),
        lng: point.lng(),
      }));
  } else if (Array.isArray(routePoints)) {
    finalPath = routePoints
      .map((point) => {
        const lat =
          point?.lat ||
          point?.latitude ||
          point?.location?.lat ||
          point?.location?.latitude;

        const lng =
          point?.lng ||
          point?.longitude ||
          point?.location?.lng ||
          point?.location?.longitude;

        if (!lat || !lng) return null;

        return {
          lat: Number(lat),
          lng: Number(lng),
        };
      })
      .filter(Boolean);
  }

  return {
    path: finalPath,
    distanceText,
    durationText,
  };
};

  const randomOtp = useMemo(() => {
    return String(Math.floor(1000 + Math.random() * 9000)).split("");
  }, [acceptedDriver?.id]);

  const registrationNumber = useMemo(() => {
    const registrations = [
      "DL 3C AG 4521",
      "DL 8S BX 9134",
      "HR 26 DK 7845",
      "UP 16 CT 2291",
      "DL 5S AB 6702",
      "HR 55 AQ 3428",
      "UP 14 EQ 9187",
      "DL 1R CN 5046",
    ];

    const driverId = Number(acceptedDriver?.id || 1);
    const index = driverId % registrations.length;

    return registrations[index];
  }, [acceptedDriver?.id]);

  const orderId = useMemo(() => {
    return "PKY" + Date.now().toString().slice(-10);
  }, []);

  const loadGoogleMap = () => {
    const googleKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    if (!googleKey) {
      console.error("Google Maps API key missing in .env");
      return;
    }

    if (window.google?.maps) {
      initMap();
      return;
    }

    const existingScript = document.getElementById("google-maps-script");

    if (existingScript) {
      existingScript.addEventListener("load", initMap);
      return;
    }

    const script = document.createElement("script");
    script.id = "google-maps-script";
   script.src = `https://maps.googleapis.com/maps/api/js?key=${googleKey}&libraries=geometry`;
    script.async = true;
    script.defer = true;
    script.onload = initMap;

    document.body.appendChild(script);
  };

  const initMap = () => {
    if (!mapRef.current || !window.google?.maps) return;

    if (!googleMapRef.current) {
      googleMapRef.current = new window.google.maps.Map(mapRef.current, {
        center: pickupLocation,
        zoom: 14,
        disableDefaultUI: true,
        zoomControl: true,
        fullscreenControl: true,
        streetViewControl: false,
        mapTypeControl: false,
      });
    }

    renderMap();
  };

  const clearMapItems = () => {
    if (pickupMarkerRef.current) pickupMarkerRef.current.setMap(null);
    if (dropMarkerRef.current) dropMarkerRef.current.setMap(null);
    if (driverMarkerRef.current) driverMarkerRef.current.setMap(null);
    if (routeLineRef.current) routeLineRef.current.setMap(null);
    if (driverLineRef.current) driverLineRef.current.setMap(null);
  };

  const renderMap = () => {
    if (!window.google?.maps || !googleMapRef.current) return;

    const map = googleMapRef.current;

    clearMapItems();

    pickupMarkerRef.current = new window.google.maps.Marker({
      map,
      position: pickupLocation,
      title: "Pickup Location",
      label: {
        text: "P",
        color: "#ffffff",
        fontWeight: "700",
      },
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 13,
        fillColor: "#2563eb",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 4,
      },
    });

    dropMarkerRef.current = new window.google.maps.Marker({
      map,
      position: dropLocation,
      title: "Drop Location",
      label: {
        text: "D",
        color: "#ffffff",
        fontWeight: "700",
      },
      icon: {
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: 13,
        fillColor: "#16a34a",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 4,
      },
    });

    driverMarkerRef.current = new window.google.maps.Marker({
      map,
      position: driverLocation,
      title: acceptedDriver?.name || "Driver",
      icon: {
        url: vehicleIcon,
        scaledSize: new window.google.maps.Size(42, 42),
        anchor: new window.google.maps.Point(21, 21),
      },
    });

const finalRoutePath =
  computedRoutePath && computedRoutePath.length > 1
    ? computedRoutePath
    : [pickupLocation, dropLocation];

routeLineRef.current = new window.google.maps.Polyline({
  map,
  path: finalRoutePath,
  geodesic: true,
  strokeColor: "#2563eb",
  strokeOpacity: 0.95,
  strokeWeight: 5,
});

    driverLineRef.current = new window.google.maps.Polyline({
      map,
      path: [driverLocation, pickupLocation],
      geodesic: true,
      strokeColor: "#f97316",
      strokeOpacity: 0.95,
      strokeWeight: 4,
      icons: [
        {
          icon: {
            path: "M 0,-1 0,1",
            strokeOpacity: 1,
            scale: 4,
          },
          offset: "0",
          repeat: "18px",
        },
      ],
    });

    const driverInfoWindow = new window.google.maps.InfoWindow({
      content: `
        <div style="font-family:Arial; min-width:170px;">
          <b>${acceptedDriver?.name || "Driver"}</b>
          <div style="font-size:12px; margin-top:4px;">
            Rating: ${acceptedDriver?.rating || "-"} ⭐<br/>
            ETA: ${acceptedDriver?.eta || "-"}<br/>
            Vehicle: ${selectedVehicle}
          </div>
        </div>
      `,
    });

    driverMarkerRef.current.addListener("click", () => {
      driverInfoWindow.open(map, driverMarkerRef.current);
    });

    const bounds = new window.google.maps.LatLngBounds();

   bounds.extend(pickupLocation);
bounds.extend(dropLocation);
bounds.extend(driverLocation);

if (computedRoutePath?.length > 1) {
  computedRoutePath.forEach((point) => {
    bounds.extend(point);
  });
}

    map.fitBounds(bounds);

    setTimeout(() => {
      if (map.getZoom() > 15) {
        map.setZoom(15);
      }
    }, 300);
  };

  useEffect(() => {
    loadGoogleMap();
  }, []);

 useEffect(() => {
  if (window.google?.maps && googleMapRef.current) {
    renderMap();
  }
}, [
  pickupLocation,
  dropLocation,
  driverLocation,
  acceptedDriver,
  vehicleIcon,
  computedRoutePath,
]);

  const handleCancelConfirm = () => {
    if (!cancelReason) return;

    setShowCancelModal(false);
    setCancelReason("");

    if (onCancel) {
      onCancel({
        reason: cancelReason,
        orderId,
        acceptedDriver,
        totalPrice,
      });
      return;
    }

    navigate("/two-wheeler");
  };

  return (
    <>
      <section className="w-full px-3 pb-6 pt-8 sm:px-4 md:px-6 md:pt-12 lg:px-0 lg:pt-0">
        {/* BACKGROUND */}
        <div className="image-section absolute left-0 top-0 -z-10 !h-[70%] w-full">
          <img
            src={banner}
            alt="bg"
            className="h-full w-full object-cover object-top"
          />
          <div className="image-overlay absolute inset-0 bg-black/30"></div>
        </div>

   <div className="mx-auto mt-8 grid w-full max-w-[1020px] grid-cols-1 overflow-hidden rounded-[26px] border border-white/80 bg-white shadow-[0_22px_70px_rgba(15,23,42,0.16)] sm:mt-4 md:mt-8 lg:mt-[80px] lg:h-[850px] lg:grid-cols-[57%_43%]">
          {/* LEFT SECTION */}
      <div className="order-2 flex h-full min-h-0 flex-col overflow-y-auto bg-white px-5 py-5 sm:px-7 md:px-6 lg:order-1 lg:px-6 lg:py-5 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
            <div className="w-full">
              {/* BACK */}
              <button
                type="button"
                onClick={onBack}
                className="mb-3 inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 transition hover:bg-slate-50"
              >
                <ArrowLeft size={17} />
                Back
              </button>

              {/* STATUS */}
              <div className="mb-3 flex flex-col gap-3 rounded-2xl border border-green-100 bg-green-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-5">
                <div className="min-w-0 flex-1">
                  <h3 className="text-[17px] font-bold text-green-700 sm:text-[18px]">
                    Driver is on the Way
                  </h3>

                  <p className="mt-1 text-sm leading-5 text-slate-600">
                    {acceptedDriver.name} is heading to pickup location{" "}
{acceptedDriver.distance} away
{routeDistanceText && (
  <span className="block text-xs text-slate-500">
    Trip route: {routeDistanceText}
    {routeDurationText ? ` • ${routeDurationText}` : ""}
  </span>
)}
                  </p>
                </div>

                <button
                  type="button"
                  className="w-fit shrink-0 rounded-xl bg-[#f97316] px-4 py-2 text-center text-sm font-bold text-white transition hover:bg-[#ea580c] sm:min-w-[72px]"
                >
                  {acceptedDriver.eta}
                </button>
              </div>

              {/* DRIVER */}
              <div className="mb-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
                <div className="flex flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex min-w-0 items-start gap-3">
                    <div className="relative shrink-0">
                      <img
                        src={acceptedDriver.image}
                        alt="driver"
                        className="h-14 w-14 rounded-full object-cover"
                      />

                      <span className="absolute -bottom-1 -right-1 flex h-6 w-6 items-center justify-center rounded-full bg-green-500 ring-2 ring-white">
                        <ShieldCheck size={14} className="text-white" />
                      </span>
                    </div>

                    <div className="min-w-0 flex-1">
                      <h4 className="inline-block max-w-full truncate rounded-full bg-orange-100 px-3 py-1 text-[14px] font-bold text-slate-800 sm:text-[15px]">
                        {acceptedDriver.name}
                      </h4>

                      <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-slate-500 sm:text-sm">
                        <span>{selectedVehicle}</span>
                        <span>|</span>
                        <span>{registrationNumber}</span>
                      </div>

                      <div className="mt-2 flex flex-wrap items-center gap-1 text-xs text-slate-500 sm:text-sm">
                        <Star
                          size={14}
                          className="fill-yellow-400 text-yellow-400"
                        />
                        <span>{acceptedDriver.rating}</span>
                        <span>•</span>
                        <span>{acceptedDriver.distance}</span>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-2 sm:flex sm:shrink-0">
                    <button
                      type="button"
                      className="flex h-10 items-center justify-center gap-2 rounded-xl bg-green-100 px-3 text-sm font-semibold text-green-700 sm:h-9 sm:w-9 sm:px-0"
                    >
                      <Phone size={18} />
                      <span className="sm:hidden">Call</span>
                    </button>

                    <button
                      type="button"
                      className="flex h-10 items-center justify-center gap-2 rounded-xl bg-blue-100 px-3 text-sm font-semibold text-blue-700 sm:h-9 sm:w-9 sm:px-0"
                    >
                      <MessageCircle size={18} />
                      <span className="sm:hidden">Chat</span>
                    </button>
                  </div>
                </div>

                <div className="flex flex-col gap-3 border-t bg-slate-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-2 sm:py-2">
                  <p className="text-sm font-medium text-slate-700">
                    Start your Order with PIN
                  </p>

                  <div className="flex gap-2 sm:gap-1">
                    {randomOtp.map((num, index) => (
                      <span
                        key={index}
                        className="flex h-8 w-8 items-center justify-center rounded-lg border bg-white text-sm font-bold text-slate-700 sm:h-7 sm:w-7"
                      >
                        {num}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* DELIVERY INFO */}
              <div className="mb-3 rounded-2xl border border-slate-200 bg-white">
                <div className="border-b px-4 py-2">
                  <h3 className="text-[18px] font-bold text-slate-800">
                    Delivery Info
                  </h3>
                </div>

                <div className="relative min-h-[75px] px-4 py-4 pl-10">
                  <div className="absolute left-5 top-6 h-[50px] border-l border-dashed border-slate-300"></div>

                  <Circle
                    size={11}
                    className="absolute left-[15px] top-5 text-blue-500"
                  />

                  <MapPin
                    size={14}
                    className="absolute left-[13px] top-[60px] text-green-600"
                    fill="currentColor"
                  />

                  <div className="space-y-4">
                    <p className="break-words text-sm leading-6 text-slate-500">
                      {formData?.pickupAddress || "Pickup address not added"}
                    </p>

                    <p className="break-words text-sm leading-6 text-slate-500">
                      {formData?.dropAddress || "Drop address not added"}
                    </p>
                  </div>
                </div>
              </div>

              {/* ADDITIONAL INFO */}
              <div className="mb-3 overflow-hidden rounded-2xl border border-slate-200 bg-white">
                <h3 className="border-b px-4 py-2 text-[18px] font-bold text-slate-800">
                  Additional Info
                </h3>

                <div className="space-y-2 px-4 py-3 text-sm">
                  <div className="flex justify-between gap-4">
                    <span className="font-semibold text-slate-500">
                      Order ID
                    </span>
                    <span className="text-right text-slate-500">{orderId}</span>
                  </div>

                  <div className="flex justify-between gap-4">
                    <span className="font-semibold text-slate-500">
                      Receiver Name
                    </span>
                    <span className="text-right text-slate-500">
                      {formData?.receiverName || "-"}
                    </span>
                  </div>

                  <div className="flex justify-between gap-4">
                    <span className="font-semibold text-slate-500">
                      Receiver Number
                    </span>
                    <span className="text-right text-slate-500">
                      {formData?.receiverMobile || "-"}
                    </span>
                  </div>

                  {formData?.deliveryType === "schedule" && (
                    <div className="flex justify-between gap-4">
                      <span className="font-semibold text-slate-500">
                        Schedule
                      </span>
                      <span className="text-right text-slate-500">
                        {formData?.scheduleDate || "-"}{" "}
                        {formData?.scheduleTime || ""}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* VEHICLE PRICE */}
              <div className="mb-3 flex items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3">
                <div className="flex items-center gap-3">
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl border border-orange-300 bg-orange-50">
                    <img
                      src={vehicleIcon}
                      alt={selectedVehicle}
                      className="h-[45px] w-[55px] object-contain"
                    />
                  </div>

                  <div>
                    <h4 className="font-bold text-slate-800">
                      {selectedVehicle}
                    </h4>
                    <p className="text-sm text-slate-500">Upto 20 kg</p>

                    {selectedExtra > 0 && (
                      <p className="text-xs font-semibold text-green-600">
                        Extra fare added: ₹{selectedExtra}
                      </p>
                    )}
                  </div>
                </div>

                <div className="text-right">
                  <p className="text-sm text-slate-500">Total Price</p>
                  <h3 className="text-[18px] font-bold text-slate-900">
                    ₹{totalPrice}
                  </h3>
                </div>
              </div>
            </div>

            {/* BUTTONS */}
            <div className="mt-auto grid grid-cols-1 gap-3 sm:grid-cols-2">
              <button
                type="button"
                onClick={() => setShowCancelModal(true)}
                className="rounded-2xl border border-red-100 bg-red-50 py-3 font-bold text-red-600 transition hover:bg-red-100"
              >
                Cancel Order
              </button>

              <button
                type="button"
                onClick={() => {}}
                className="w-full rounded-2xl bg-[#1f2d3f] py-3 font-semibold text-white transition hover:opacity-90"
              >
                Contact Support
              </button>
            </div>
          </div>

          {/* RIGHT REAL MAP */}
          <div className="order-1 flex h-[420px] bg-slate-100 p-4 sm:h-[460px] md:h-[500px] lg:order-2 lg:h-full lg:p-5">
            <div className="relative h-full w-full overflow-hidden rounded-3xl border border-white/70 bg-white shadow-inner">
              <div ref={mapRef} className="h-full w-full" />
            </div>
          </div>
        </div>
      </section>

      {showCancelModal && (
        <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 px-4">
          <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl">
            <div className="mb-4 flex items-center justify-between">
              <div>
                <h3 className="text-lg font-bold text-slate-900">
                  Cancel Order
                </h3>
                <p className="mt-1 text-sm text-slate-500">
                  Please select a cancellation reason.
                </p>
              </div>

              <button
                type="button"
                onClick={() => {
                  setShowCancelModal(false);
                  setCancelReason("");
                }}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-600 hover:bg-slate-200"
              >
                <X size={18} />
              </button>
            </div>

            <div className="mb-5">
              <label className="mb-2 block text-sm font-semibold text-slate-700">
                Cancellation Reason
              </label>

              <select
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
                className="w-full rounded-lg border border-slate-300 bg-white px-3 py-3 text-sm text-slate-700 outline-none focus:border-red-400 focus:ring-2 focus:ring-red-100"
              >
                <option value="">Select reason</option>

                {cancellationReasons.map((reason) => (
                  <option key={reason} value={reason}>
                    {reason}
                  </option>
                ))}
              </select>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              <button
                type="button"
                onClick={() => {
                  setShowCancelModal(false);
                  setCancelReason("");
                }}
                className="rounded-lg border border-slate-200 bg-white py-3 font-bold text-slate-700 hover:bg-slate-50"
              >
                Keep Order
              </button>

              <button
                type="button"
                disabled={!cancelReason}
                onClick={handleCancelConfirm}
                className={`rounded-lg py-3 font-bold text-white transition ${
                  cancelReason
                    ? "bg-red-600 hover:bg-red-700"
                    : "cursor-not-allowed bg-red-300"
                }`}
              >
                Confirm Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TrackingOrderCard;